.ar{flex-shrink:0;}